import { render, staticRenderFns } from "./WholeCalendar.vue?vue&type=template&id=3da7a7f2"
import script from "./WholeCalendar.vue?vue&type=script&lang=js"
export * from "./WholeCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports